import config from 'veui/managers/config'

config.defaults(
  {
    columns: 24,
    gutter: 20,
    margin: 20
  },
  'gridcontainer'
)
